// Constants
/**
 * The Custom View dialog flows, selected by the shared container. Save and rename render the same
 * naming dialog; delete renders a separate confirmation dialog.
 */ export var CustomViewDialogMode = /*#__PURE__*/ function(CustomViewDialogMode) {
    /** Save the current plan view as a new Custom View */ CustomViewDialogMode[CustomViewDialogMode["Save"] = 0] = "Save";
    /** Rename an existing Custom View */ CustomViewDialogMode[CustomViewDialogMode["Rename"] = 1] = "Rename";
    /** Delete an existing Custom View */ CustomViewDialogMode[CustomViewDialogMode["Delete"] = 2] = "Delete";
    return CustomViewDialogMode;
}({});
